import {
  Box,
  Button,
  Flex,
  HTMLChakraProps,
  Icon,
  Menu,
  MenuButton,
  MenuButtonProps,
  MenuList,
  MenuListProps,
  useToast,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAccount, useSwitchChain } from 'wagmi';

import { CustomMenuItem, DownIcon } from './CustomMenuItem';
import { CHAIN_INFO } from '../constants/chain';
import CustomImage from './CustomImage';

const NetworkDropDown = ({
  chain,
  ...rest
}: {
  chain?: {
    hasIcon: boolean;
    iconUrl?: string | undefined;
    iconBackground?: string | undefined;
    id: number;
    name?: string | undefined;
    unsupported?: boolean | undefined;
  };
} & MenuListProps) => {
  const { isConnected } = useAccount();
  const [isOpen, setIsOpen] = useState(false);
  const toast = useToast();
  const location = useLocation();
  const isGamePage = location.pathname.startsWith('/game');

  const { switchChain } = useSwitchChain({
    mutation: {
      onError(error) {
        toast({ title: error?.message, status: 'error' });
      },
      onSuccess(data) {
        toast({ title: 'Switch network successfully', status: 'success' });
      },
    },
  });

  const switchNetwork = (id: number) => {
    if (isConnected && chain?.id !== id) {
      switchChain({ chainId: id });
    }
  };

  if (!isConnected) return null;

  return (
    <Menu
      autoSelect={false}
      isOpen={isOpen && !isGamePage}
      onOpen={() => {
        if (!isGamePage) setIsOpen(true);
      }}
      onClose={() => setIsOpen(false)}
    >
      <MenuButton
        as={Button}
        variant={chain?.unsupported ? 'normal' : 'outline'}
        borderRadius={'6px'}
        isDisabled={isGamePage}
        color={chain?.unsupported ? 'white' : isOpen ? 'brand' : 'c-103'}
        bg={chain?.unsupported ? 'errorRed' : 'transparent'}
        _hover={chain?.unsupported ? ({ bg: 'errorRed' } as any) : undefined}
        _disabled={{
          bg: 'transparent',
          cursor: 'not-allowed',
        }}
        rightIcon={
          isGamePage ? undefined : (
            <DownIcon transform={isOpen ? 'rotateX(180deg)' : 'none'} />
          )
        }
        leftIcon={
          <Box
            // background={chain.iconBackground}
            borderRadius="full"
            overflow="hidden"
          >
            <CustomImage
              alt={chain?.name ?? 'Chain icon'}
              src={
                chain?.iconUrl ??
                CHAIN_INFO.find(item => item.id === chain?.id)?.iconUrl
              }
              w={'2rem'}
              h={'2rem'}
            />
          </Box>
        }
        {...(rest as MenuButtonProps)}
      >
        {chain?.unsupported ? 'Wrong network' : chain?.name}
      </MenuButton>
      <MenuList
        color="c-103"
        zIndex={101}
        fontWeight={'medium'}
        bgColor={'c-106'}
        border="none"
        p={2}
        borderRadius={'6px'}
        minWidth="0"
        fontSize="md"
        mt={'-6px'}
        {...rest}
      >
        {CHAIN_INFO.map(({ name, iconUrl, id }) => (
          <CustomMenuItem
            key={id}
            icon={<CustomImage src={iconUrl} w={6} h={6} />}
            onClick={() => {
              switchNetwork(id);
            }}
          >
            <Flex justifyContent={'space-between'} w="100%">
              {name}
              {id === chain?.id && (
                <Icon
                  width={6}
                  height={6}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6 12L10 16L18 8" stroke="#0F9B25" strokeWidth="2" />
                </Icon>
              )}
            </Flex>
          </CustomMenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default NetworkDropDown;
